<template>
	<div>
		<square-box
			:focused="selected"
			:checked="completed"
			:name="job.name"
			:job="job"
			:status="job.status"
			:index-tab="indexTab"
			@onEditClick="$emit('editionClick', job)"
			@onDescriptionClick="$emit('descriptionClick', job)"
			@onViewPdf="$emit('viewPdfClick', job)"
			@onChangeStatus="$emit('onChangeStatus', { status: $event, selectedJob: job})"
			@onDeleteClick="onDeleteClick"
		></square-box>
		
		<!-- Barra de progreso minimalista -->
		<div 
			class="job-progress-container tw-mt-1"
			:style="{ 
				'--progress-width': progressPercentage + '%',
				'--progress-color': progressColor
			}"
		>
			<div class="progress-bar-minimal">
				<div class="progress-track-minimal">
					<div class="progress-fill-minimal"></div>
				</div>
				<div class="progress-info-inline">
					<span class="progress-percentage">{{ progressPercentage }}%</span>
					<div v-if="progressPercentage === 100" class="check-icon">✓</div>
					<div v-else class="warning-icon">⚠</div>
				</div>
			</div>
		</div>
		
		<p-confirm-dialog ref="confirmDialog" />
	</div>
</template>

<script>
import PConfirmDialog from '@/modules/shared/components/ui/p-confirm-dialog';
import SquareBox from '@/modules/job-profile/components/content/c-square-box';
import { calculateJobProgress, getCompletedFieldsCount } from '@/modules/job-profile/helpers/helpers';

export default {
	name: 'guideline-model-job-item',
	components: { SquareBox, PConfirmDialog },
	props: ['job', 'selected', 'completed', 'indexTab'],
	computed: {
		progressPercentage() {
			const progress = calculateJobProgress(this.job);
			return progress;
		},
		completedFieldsCount() {
			const count = getCompletedFieldsCount(this.job);
			return count;
		},
		progressColor() {
			const progress = this.progressPercentage;
			if (progress <= 33) {
				return '#f44336'; // Rojo
			} else if (progress <= 66) {
				return '#ff9800'; // Amarillo/Naranja
			}
			return '#4CAF50'; // Verde
		},

	},
	methods: {
		onDeleteClick() {
			this.$refs.confirmDialog.showConfirm({
				onOk: () => {
					this.$emit('deleteClick', this.job);
				},
				title: `¿Seguro que desea eliminar "${this.job.name}" de la lista?`,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.job-progress-container {
	.progress-bar-minimal {
		display: flex;
		align-items: center;
		gap: 6px;
		height: 16px; // Altura fija más pequeña
		
		.progress-track-minimal {
			flex: 1;
			height: 4px; // Barra más delgada
			background: #e5e7eb;
			border-radius: 2px;
			overflow: hidden;
			position: relative;
			
			.progress-fill-minimal {
				position: absolute;
				top: 0;
				left: 0;
				height: 100%;
				width: var(--progress-width, 0%);
				border-radius: 2px;
				background: var(--progress-color, #4CAF50);
				transition: width 0.8s ease-out;
			}
		}
		
		.progress-info-inline {
			display: flex;
			align-items: center;
			gap: 4px;
			min-width: 35px; // Ancho mínimo para el porcentaje
			
			.progress-percentage {
				font-size: 10px;
				color: #6b7280;
				font-weight: 500;
				line-height: 1;
			}
			
			.check-icon {
				font-size: 12px;
				color: var(--progress-color, #4CAF50);
				font-weight: bold;
				line-height: 1;
				animation: checkPop 0.3s ease-out;
			}
			
			.warning-icon {
				font-size: 12px;
				color: var(--progress-color, #ff9800);
				font-weight: bold;
				line-height: 1;
				animation: warningPulse 2s ease-in-out infinite;
			}
		}
	}
}

@keyframes checkPop {
	0% {
		transform: scale(0);
		opacity: 0;
	}
	50% {
		transform: scale(1.2);
	}
	100% {
		transform: scale(1);
		opacity: 1;
	}
}

@keyframes warningPulse {
	0%, 100% {
		opacity: 1;
		transform: scale(1);
	}
	50% {
		opacity: 0.6;
		transform: scale(0.95);
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/jobs-profile/model-job-item.vue